module.exports = __webpack_public_path__ + "static/media/members.7fa1fb60.svg";